import { CustomerTouchPoint } from "@eucoms/customer-touchpoints-tracker";

export class MockDataOption {
  name: string;
  data: CustomerTouchPoint
}

export const mockDataOptions: MockDataOption[] = [
  {
    name: "budget_billing_check_api_error",
    data: {
      id: "mock-budget_billing_check_api_error",
      accountNumber: "1111122222",
      status: "TechnicalFailure",
      type: "TaskAttempt",
      channel: "Web",
      opCo: "BGE",
      timestamp: new Date("2025-04-23T00:00:00.000Z"),
      target: "Check Eligibility",
      customerInfo: {
        customerNumber: "9898989898",
        phoneNumber: "5555555555",
        premiseIds: ["201", "202"]
      },
      processingContext: {
        product: "Billing & Payments",
        journey: "Budget Billing Status",
        step: "Check Eligibility",
        resultCode: "Error/APIFailure",
        resultDescription: "The resource you are looking for has been removed, had its name changed, or is temporarily unavailable."
      },
      dependency: {
        service: "",
        operation: "",
        endpoint: "/.euapi/eubnpapi/payment-options/budget-billing/accounts/5731120777",
        httpStatusCode: 403
      },
    } as CustomerTouchPoint
  },
  {
    name: "budget_billing_check_ineligible",
    data: {
      id: "mock-budget_billing_check_ineligible",
      accountNumber: "1111122222",
      status: "TechnicalFailure",
      type: "TaskAttempt",
      channel: "Web",
      opCo: "PECO",
      timestamp: new Date("2025-04-23T00:00:00.000Z"),
      target: "Check Eligibility",
      customerInfo: {
        customerNumber: "9898989898",
        phoneNumber: "1234567890",
        premiseIds: ["301", "302"]
      },
      processingContext: {
        product: "Billing & Payments",
        journey: "Budget Billing Status",
        step: "Check Eligibility",
        resultCode: "Ineligible/General",
        resultDescription: "User is not eligible for Budget Billing",
        extensionData: {
          isBudgetBillingAvailable: false,
          enrolled: false,
          averageMonthlyBill: null,
          programStatusCode: "01"
        } as any
      },
      dependency: {
        service: "",
        operation: "",
        endpoint: "/.euapi/mobile/custom/auth/accounts/8576536000/billing/budget",
        httpStatusCode: 200
      }
    } as CustomerTouchPoint
  },
  {
    name: "budget_billing_ComEd_ineligible",
    data: {
      id: "mock-budget_billing_ComEd_ineligible",
      accountNumber: "1111122222",
      status: "FunctionalFailure",
      type: "TaskAttempt",
      channel: "MobileApp",
      opCo: "ComEd",
      timestamp: new Date("2025-04-23T00:00:00.000Z"),
      sessionId: undefined,
      target: "Check Eligibility",
      customerInfo: {
        customerNumber: "9898989898",
        phoneNumber: "1234567890",
        premiseIds: ["101", "102"]
      },
      processingContext: {
        product: "Billing & Payments",
        journey: "Budget Billing Status",
        step: "Check Eligibility",
        resultCode: "Ineligible/AccountNotCurrent",
        resultDescription: "Ineligible for Budget - Account not on correct budget billing procedure",
        extensionData: {
          isBudgetBillingAvailable: false,
          enrolled: false,
          averageMonthlyBill: 70,
          programStatusCode: "01"
        } as any
      },
      dependency: {
        service: "",
        operation: "",
        endpoint: "/.euapi/mobile/custom/auth/accounts/0002233333/billing/budget",
        httpStatusCode: 200
      },
    } as CustomerTouchPoint
  },
  {
    name: "budget_billing_enroll_api_error",
    data: {
      id: "mock-budget_billing_enroll_api_error",
      accountNumber: "1111122222",
      status: "TechnicalFailure",
      type: "TaskAttempt",
      channel: "Web",
      opCo: "DPL",
      timestamp: new Date("2025-04-23T00:00:00.000Z"),
      sessionId: undefined,
      target: "Enroll",
      customerInfo: {
        customerNumber: "9898989898",
        phoneNumber: "1234567890",
        premiseIds: ["301", "302"]
      },
      processingContext: {
        product: "Billing & Payments",
        journey: "Budget Billing Enrollment",
        step: "Enroll",
        resultCode: "Enroll/Error/APIFailure",
        resultDescription: "The enrollment API failed."
      },
      dependency: {
        service: "",
        operation: "",
        endpoint: "/.euapi/mobile/custom/auth/accounts/55011790973/billing/budget",
        httpStatusCode: 403
      },
    } as CustomerTouchPoint
  },
  {
    name: "budget_billing_ineligible_finaled",
    data: {
      id: "mock-budget_billing_ineligible_finaled",
      accountNumber: "1111122222",
      status: "FunctionalFailure",
      type: "TaskAttempt",
      channel: "MobileApp",
      opCo: "PEPCO",
      timestamp: new Date("2025-04-23T00:00:00.000Z"),
      sessionId: undefined,
      target: "Enroll",
      customerInfo: {
        customerNumber: "9898989898",
        phoneNumber: "5555555555",
        premiseIds: ["101", "102"]
      },
      processingContext: {
        product: "Billing & Payments",
        journey: "Budget Billing Enrollment",
        step: "Enroll",
        resultCode: "Ineligible/AccountFinaled",
        resultDescription: "The account is recently closed at this address. (0300)"
      },
      dependency: {
        service: "",
        operation: "",
        endpoint: "/.euapi/eubnpapi/payment-options/budget-billing/accounts/5731120777",
        httpStatusCode: 200
      },
    } as CustomerTouchPoint
  },
  {
    name: "budget_billing_enroll_large_commercial",
    data: {
      id: "mock-budget_billing_enroll_large_commercial",
      accountNumber: "1111122222",
      status: "FunctionalFailure",
      type: "TaskAttempt",
      channel: "IVR",
      opCo: "BGE",
      timestamp: new Date("2025-04-23T00:00:00.000Z"),
      sessionId: undefined,
      target: "Enroll",
      customerInfo: {
        customerNumber: "9898989898",
        phoneNumber: "9876543210",
        premiseIds: ["201", "202"]
      },
      processingContext: {
        product: "Billing & Payments",
        journey: "Budget Billing Enrollment",
        step: "Check Eligibility",
        resultCode: "Ineligible/Largecommercial",
        resultDescription: "The account is a large commercial or industrial account."
      },
      dependency: {
        service: "",
        operation: "",
        endpoint: "/.euapi/mobile/custom/auth/accounts/55011790973/billing/budget",
        httpStatusCode: 200
      },
    } as CustomerTouchPoint
  },
  {
    name: "budget_billing_peco_small_business",
    data: {
      id: "mock-budget_billing_ineligible_0301",
      accountNumber: "1111122222",
      status: "FunctionalFailure",
      type: "TaskAttempt",
      channel: "IVR",
      opCo: "PECO",
      timestamp: new Date("2025-04-23T00:00:00.000Z"),
      sessionId: undefined,
      target: "Check Eligibility",
      customerInfo: {
        customerNumber: "9898989898",
        phoneNumber: "5555555555",
        premiseIds: ["201", "202"]
      },
      processingContext: {
        product: "Billing & Payments",
        journey: "Budget Billing Status",
        step: "Check Eligibility",
        resultCode: "Ineligible/SmallCommercialHomeBusiness",
        resultDescription: "The account is a small commercial/home based business."
      },
      dependency: {
        service: "",
        operation: "",
        endpoint: "/.euapi/eubnpapi/payment-options/budget-billing/accounts/5731120777",
        httpStatusCode: 200
      },
    } as CustomerTouchPoint
  },
  {
    name: "budget_billing_ineligible_0312",
    data: {
      id: "mock-budget_billing_ineligible_0312",
      accountNumber: "1111122222",
      status: "FunctionalFailure",
      type: "TaskAttempt",
      channel: "IVR",
      opCo: "PEPCO",
      timestamp: new Date("2025-04-23T00:00:00.000Z"),
      sessionId: undefined,
      target: "Check Eligibility",
      customerInfo: {
        customerNumber: "CUST002",
        phoneNumber: "5555555555",
        premiseIds: ["101", "102"]
      },
      processingContext: {
        product: "Billing & Payments",
        journey: "Budget Billing Status",
        step: "Check Eligibility",
        resultCode: "Ineligible/LessThan12Months",
        resultDescription: "The account has less than 12 months of past energy use at the address. (0312)"
      },
      dependency: {
        service: "",
        operation: "",
        endpoint: "/.euapi/eubnpapi/payment-options/budget-billing/accounts/5731120777",
        httpStatusCode: 200
      },
    } as CustomerTouchPoint
  },
  {
    name: "budget_billing_ineligible_NEM",
    data: {
      id: "mock-budget_billing_ineligible_NEM",
      accountNumber: "1111122222",
      status: "FunctionalFailure",
      type: "TaskAttempt",
      channel: "IVR",
      opCo: "BGE",
      timestamp: new Date("2025-04-23T00:00:00.000Z"),
      sessionId: undefined,
      target: "Check Eligibility",
      customerInfo: {
        customerNumber: "9898989898",
        phoneNumber: "1234567890",
        premiseIds: ["301", "302"]
      },
      processingContext: {
        product: "Billing & Payments",
        journey: "Budget Billing Status",
        step: "Check Eligibility",
        resultCode: "Ineligible/NEMAccount",
        resultDescription: "The account belongs to a solar customer and online enrollment isn't available. (0310)"
      },
      dependency: {
        service: "",
        operation: "",
        endpoint: "/.euapi/eubnpapi/payment-options/budget-billing/accounts/5731120777",
        httpStatusCode: 200
      },
    } as CustomerTouchPoint
  },
  {
    name: "budget_billing_unenroll_api_error",
    data: {
      id: "mock-budget_billing_unenroll_api_error",
      accountNumber: "1111122222",
      status: "TechnicalFailure",
      type: "TaskAttempt",
      channel: "Web",
      opCo: "BGE",
      timestamp: new Date("2025-04-23T00:00:00.000Z"),
      sessionId: undefined,
      target: "Unenroll",
      customerInfo: {
        customerNumber: "9898989898",
        phoneNumber: "5555555555",
        premiseIds: ["201", "202"]
      },
      processingContext: {
        product: "Billing & Payments",
        journey: "Budget Billing Unenrollment",
        step: "Unenroll",
        resultCode: "Unenroll/Error/APIFailure",
        resultDescription: "The resource you are looking for has been removed, had its name changed, or is temporarily unavailable."
      },
      dependency: {
        service: "",
        operation: "",
        endpoint: "/.euapi/eubnpapi/payment-options/budget-billing/accounts/5731120777",
        httpStatusCode: 403
      },
    } as CustomerTouchPoint
  },
  {
    name: "ebill_check_500",
    data: {
      id: "mock-ebill_check_500",
      accountNumber: "1111122222",
      status: "TechnicalFailure",
      type: "TaskAttempt",
      channel: "IVR",
      opCo: "ComEd",
      timestamp: new Date("2025-04-23T00:00:00.000Z"),
      sessionId: undefined,
      target: "Check Eligibility",
      customerInfo: {
        customerNumber: "9898989898",
        phoneNumber: "5555555555",
        premiseIds: ["101", "102"]
      },
      processingContext: {
        product: "Billing & Payments",
        journey: "eBill Status",
        step: "Check Eligibility",
        resultCode: "APIFailure",
        resultDescription: ""
      },
      dependency: {
        service: "",
        operation: "",
        endpoint: "/.euapi/mobile/custom/auth/accounts/0002233333/billing/paperless",
        httpStatusCode: 500
      },
    } as CustomerTouchPoint
  },
  {
    name: "ebill_enroll_api_error",
    data: {
      id: "mock-ebill_enroll_api_error",
      accountNumber: "1111122222",
      status: "TechnicalFailure",
      type: "TaskAttempt",
      channel: "Web",
      opCo: "ComEd",
      timestamp: new Date("2025-04-23T00:00:00.000Z"),
      sessionId: undefined,
      target: "Enroll",
      customerInfo: {
        customerNumber: "9898989898",
        phoneNumber: "5555555555",
        premiseIds: ["301", "302"]
      },
      processingContext: {
        product: "Billing & Payments",
        journey: "eBill Enrollment",
        step: "Enroll",
        resultCode: "EnrollSingleError",
        resultDescription: "Failed to enroll to ebill",
        extensionData: {
          ebillInfo: {
            account_id: "55032686275",
            email: "BCSZBOUU@XYZ.COM",
            isEligible: true,
            isEnrolled: false,
            isFinaled: false,
            address: "2121 1st ST SW 818 WASHINGTON DC 20024"
          }
        } as any
      },
      dependency: {
        service: "",
        operation: "",
        endpoint: "/.euapi/mobile/custom/auth/accounts/0002233333/billing/paperless",
        httpStatusCode: 500
      },
    } as CustomerTouchPoint
  },
  {
    name: "ebill_ineligible",
    data: {
      id: "mock-ebill_ineligible",
      accountNumber: "1111122222",
      status: "FunctionalFailure",
      type: "TaskAttempt",
      channel: "Web",
      opCo: "ComEd",
      timestamp: new Date("2025-04-23T00:00:00.000Z"),
      sessionId: undefined,
      target: "Check Eligibility",
      customerInfo: {
        customerNumber: "9898989898",
        phoneNumber: "9876543210",
        premiseIds: ["101", "102"]
      },
      processingContext: {
        product: "Billing & Payments",
        journey: "eBill Status",
        step: "Check Eligibility",
        resultCode: "Ineligible",
        resultDescription: "Ineligible - has to confirm email",
        extensionData: {
          ebillInfo: {
            account_id: "55032686275",
            email: "BCSZBOUU@XYZ.COM",
            isEligible: true,
            isEnrolled: false,
            isFinaled: false,
            address: "2121 1st ST SW 818 WASHINGTON DC 20024"
          }
        } as any
      },
      dependency: {
        service: "",
        operation: "",
        endpoint: "/.euapi/mobile/custom/auth/accounts/0002233333/billing/paperless",
        httpStatusCode: 500
      },
    } as CustomerTouchPoint
  },
  {
    name: "ebill_unenroll",
    data: {
      id: "mock-ebill_unenroll",
      accountNumber: "1111122222",
      status: "TechnicalFailure",
      type: "TaskAttempt",
      channel: "Web",
      opCo: "ComEd",
      timestamp: new Date("2025-04-23T00:00:00.000Z"),
      sessionId: undefined,
      target: "Unenroll",
      customerInfo: {
        customerNumber: "CUST002",
        phoneNumber: "5555555555",
        premiseIds: ["201", "202"]
      },
      processingContext: {
        product: "Billing & Payments",
        journey: "eBill Unenrollment",
        step: "Unenroll",
        resultCode: "UnenrollSingleError",
        resultDescription: "The unenrollment API failed for all accounts"
      },
      dependency: {
        service: "",
        operation: "",
        endpoint: "/.euapi/mobile/custom/auth/accounts/0002233333/billing/paperless",
        httpStatusCode: 500
      },
    } as CustomerTouchPoint
  },
  {
    name: "ebill_unenroll_api_error",
    data: {
      id: "mock-ebill_unenroll_api_error",
      accountNumber: "1111122222",
      status: "TechnicalFailure",
      type: "TaskAttempt",
      channel: "IVR",
      opCo: "DPL",
      timestamp: new Date("2025-04-23T00:00:00.000Z"),
      sessionId: undefined,
      target: "Unenroll",
      customerInfo: {
        customerNumber: "9898989898",
        phoneNumber: "5555555555",
        premiseIds: ["101", "102"]
      },
      processingContext: {
        product: "Billing & Payments",
        journey: "eBill Unenrollment",
        step: "Unenroll",
        resultCode: "UnenrollSingleError",
        resultDescription: "The resource you are looking for has been removed, had its name changed, or is temporarily unavailable."
      },
      dependency: {
        service: "",
        operation: "",
        endpoint: "/.euapi/mobile/custom/auth/accounts/55011790973/billing/paperless",
        httpStatusCode: 404
      },
    } as CustomerTouchPoint
  },
  {
    name: "outage_account_not_found",
    data: {
      id: "mock-outage_account_not_found",
      accountNumber: "00000000000",
      status: "FunctionalFailure",
      type: "TaskAttempt",
      channel: "Web",
      opCo: "BGE",
      timestamp: new Date("2025-04-23T00:00:00.000Z"),
      sessionId: "2025-03-28-ReportOutage-nonexistent",
      target: "Eligibility Check",
      customerInfo: {
        phoneNumber: "4439998888",
        customerNumber: "1087140000",
        premiseIds: ["7111440000"]
      },
      processingContext: {
        product: "Outages",
        journey: "Report Outage",
        step: "Eligibility Check",
        resultCode: "FN-ACCT-NOTFOUND",
        resultDescription: "Account could not be found.",
        extensionData: {
          "originalResponse": {
            "success":false,
            "meta":{
              "code":"FN-ACCT-NOTFOUND",
              "description":"Account not found"
            }
          }
        } as any
      },
      dependency: {
        service: "OutageService",
        operation: "OUTAGE_QUERY",
        endpoint: "/api/anon/BGE/outage/query",
        httpStatusCode: 200
      },
    } as CustomerTouchPoint
  },
  {
    name: "outage_call_volume",
    data: {
      id: "mock-outage_call_volume",
      accountNumber: "50988765432",
      status: "TechnicalFailure",
      type: "TaskAttempt",
      channel: "Web",
      opCo: "BGE",
      timestamp: new Date("2025-04-23T00:00:00.000Z"),
      sessionId: "2025-03-28-ReportOutage-x4z5y6w7",
      target: "Check Eligibility",
      customerInfo: {
        phoneNumber: "4106007788",
        customerNumber: "1087140000",
        premiseIds: ["7111440000"]
      },
      processingContext: {
        product: "Outages",
        journey: "Report Outage",
        step: "Check Eligibility",
        resultCode: "HTTP-403",
        resultDescription: "Out of call volume. Quota will be replenished in 10 minutes."
      },
      dependency: {
        service: "OutageService",
        operation: "QUERY_ELIGIBILITY",
        endpoint: "/api/anon/BGE/outage/query",
        httpStatusCode: 403
      },
    } as CustomerTouchPoint
  },
  {
    name: "outage_meter_non_communication",
    data: {
      id: "mock-outage_meter_non_communication",
      accountNumber: "41234567890",
      status: "FunctionalFailure",
      type: "TaskAttempt",
      channel: "Web",
      opCo: "BGE",
      timestamp: new Date("2025-04-23T00:00:00.000Z"),
      sessionId: "2025-03-28-ReportOutage-a1b2c3d4",
      target: "Meter Ping",
      customerInfo: {
        phoneNumber: "4105551212",
        customerNumber: "1087140000",
        premiseIds: ["7722990000"]
      },
      processingContext: {
        product: "Outages",
        journey: "Report Outage",
        step: "Meter Ping",
        resultCode: "FN-METER-COMM",
        resultDescription: "Meter is not communicating."
      },
      dependency: {
        service: "OutageService",
        operation: "PING_METER",
        endpoint: "/api/anon/BGE/outage/ping",
        httpStatusCode: 200
      },
    } as CustomerTouchPoint
  },
  {
    name: "outage_type",
    data: {
      id: "mock-outage_type-1",
      accountNumber: "48900123456",
      status: "FunctionalFailure",
      type: "TaskAttempt",
      channel: "MobileApp",
      opCo: "BGE",
      timestamp: new Date("2025-04-23T00:00:00.000Z"),
      sessionId: "2025-03-28-ReportOutage-b7e8f9g0",
      target: "Submit Outage Type",
      customerInfo: {
        phoneNumber: "4437894560",
        customerNumber: "1087140000",
        premiseIds: ["8613420000"]
      },
      processingContext: {
        product: "Outages",
        journey: "Report Outage",
        step: "Submit Outage Type",
        resultCode: "TC-UNKOWN",
        resultDescription: "Corporate Code: null – cannot be null"
      },
      dependency: {
        service: "OutageService",
        operation: "REPORT_OUTAGE",
        endpoint: "auth/accounts/4321545/outage",
        httpStatusCode: 200
      },
    } as CustomerTouchPoint
  },

  {
    name: "outage_too_many_accounts",
    data: {
      id: "mock-outage_too_many_accounts",
      accountNumber: "4309876001",
      status: "FunctionalFailure",
      type: "TaskAttempt",
      channel: "MobileApp",
      opCo: "BGE",
      timestamp: new Date("2025-04-23T00:00:00.000Z"),
      sessionId: "2025-03-06-reportoutage-session-003",
      target: "Account Lookup",
      customerInfo: {
        phoneNumber: "4438887766",
        customerNumber: "1087140000",
        premiseIds: ["9212345678"]
      },
      processingContext: {
        product: "Outages",
        journey: "Report Outage",
        step: "Account Lookup",
        resultCode: "FN-ACCT-MULTIPLE",
        resultDescription: "Too many accounts."
      },
      dependency: {
        service: "OutageService",
        operation: "ACCOUNT_LOOKUP",
        endpoint: "/api/anon/BGE/outage",
        httpStatusCode: 200
      },
    } as CustomerTouchPoint
  },
  {
    name: "ISUM_invalid_zip_code",
    data: {
      id: "mock-ISUM_invalid_zip_code",
      accountNumber: "5101234987",
      status: "FunctionalFailure",
      type: "TaskAttempt",
      channel: "Web",
      opCo: "BGE",
      timestamp: new Date("2025-04-23T00:00:00.000Z"),
      sessionId: "2025-03-25-Move-a82bde5f",
      target: "Zip Code Validation",
      customerInfo: {
        phoneNumber: "4105557890",
        customerNumber: "CM3210001",
        premiseIds: ["7654321000"]
      },
      processingContext: {
        product: "ISUM",
        journey: "Move",
        step: "Zip Code Validation",
        resultCode: "validatezipcodeerror",
        resultDescription: "Bad Input Data"
      },
      dependency: {
        service: "AddressValidationService",
        operation: "ZIPCODE_VALIDATE",
        endpoint: "/anon/BGE/zipcode/validate/00000",
        httpStatusCode: 400
      },
    } as CustomerTouchPoint
  },
  {
    name: "ISUM_address_lookup_empty",
    data: {
      id: "mock-ISUM_address_lookup_empty",
      accountNumber: "5109876543",
      status: "FunctionalFailure",
      type: "TaskAttempt",
      channel: "Web",
      opCo: "BGE",
      timestamp: new Date("2025-04-23T00:00:00.000Z"),
      sessionId: "2025-03-26-Move-fg7192de",
      target: "Address Lookup",
      customerInfo: {
        phoneNumber: "4431112222",
        customerNumber: "CM7770001",
        premiseIds: ["8889900000"]
      },
      processingContext: {
        product: "ISUM",
        journey: "Move",
        step: "Address Lookup",
        resultCode: "accountlookuperror",
        resultDescription: "No matching address found"
      },
      dependency: {
        service: "AddressLookupService",
        operation: "LOOKUP_ADDRESS",
        endpoint: "/custom/anon/BGE/address/lookup",
        httpStatusCode: 200
      },
    } as CustomerTouchPoint
  },
  {
    name: "ISUM_stop_verification_error",
    data: {
      id: "mock-ISUM_stop_verification_error",
      accountNumber: "5104641785",
      status: "FunctionalFailure",
      type: "TaskAttempt",
      channel: "MobileApp",
      opCo: "BGE",
      timestamp: new Date("2025-04-23T00:00:00.000Z"),
      sessionId: "2025-03-26-Move-StopVerify123",
      target: "Stop Service Verification",
      customerInfo: {
        phoneNumber: "4435153066",
        customerNumber: "8026084662",
        premiseIds: ["9223370000"]
      },
      processingContext: {
        product: "ISUM",
        journey: "Move",
        step: "Stop Service Verification",
        resultCode: "stop_schedule_error_daterequired",
        resultDescription: "Multiple matching accounts found for stop verification"
      },
      dependency: {
        service: "MoveEligibilityService",
        operation: "STOP_VERIFICATION",
        endpoint: "/api/anon/BGE/service/stop/verification",
        httpStatusCode: 200
      },
    } as CustomerTouchPoint
  },
  {
    name: "ISUM_address_fail_storm_mode",
    data: {
      id: "mock-ISUM_address_fail_storm_mode",
      accountNumber: "5111887654",
      status: "Information",
      type: "SystemEvent",
      channel: "Web",
      opCo: "BGE",
      timestamp: new Date("2025-04-23T00:00:00.000Z"),
      sessionId: "2025-03-25-Move-stormCheck",
      target: "Address Availability",
      customerInfo: {
        phoneNumber: "4432223344",
        customerNumber: "CM9088123",
        premiseIds: ["5042960000"]
      },
      processingContext: {
        product: "ISUM",
        journey: "Move",
        step: "Address Availability",
        resultCode: "FN-STORM-MODE",
        resultDescription: "Meter ping is not available during storm",
        extensionData: {
          "originalResponse": {
            "success":false,
            "meta":{
              "code":"FN-STORM-MODE",
              "description":"Meter ping is not available during storm"
            }
          }
        } as any
      },
      dependency: {
        service: "MeterPingService",
        operation: "ADDRESS_AVAILABILITY",
        endpoint: "/anon/BGE/start/address/availability/5042960000",
        httpStatusCode: 200
      },
    } as CustomerTouchPoint
  }
];
